import axios from "axios"; // ✅ Correct

// Constants (You should define these properly or import them)
const APP_LINK_ANDROID = "https://play.google.com/store/apps/details?id=com.example";
const APP_LINK_IOS = "https://apps.apple.com/app/id0000000000";
const APP_NAME = "JITO JOBS VADODARA";
const APP_VERSION_ANDROID = 1;
const APP_VERSION_IOS = 1;

const WEB_SERVICES = () => {
  return process.env.REACT_APP_API_URL;
};

const showToast = (msg) => alert(msg || "Something went wrong");

function instance(options = {}) {
  const token = localStorage.getItem("token") || "";

  const axiosClient = axios.create({
    baseURL: WEB_SERVICES(), //`${WEB_SERVICES}`,
    timeout: 30000,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });

  return axiosClient;
}

function errorHandling(error) {
  console.log(
    "____________error___response______",
    error,
    error?.response,
    error?.response?.data?.message
  );

  var message = "";
  if (!navigator.onLine) {
    message = "No internet connection. Please check your internet connection.";
  } else {
    message = error?.response?.data?.message || error?.message || "The servers are not available!";
  }

  // const message = error?.response?.data?.message || "The servers are not available!";
  showToast(message);

  if (error?.response?.status === 401) {
    resetDetail();
    window.location.href = "/authentication/admin-sign-in";
  }
}

export const resetDetail = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("isEmployee");
};

function checkVersionUpdate(res) {
  return false;
}

//AUTHENTICATION
export const adminLogin = async (params) => {
  try {
    const res = await instance().post("auth/admin-login", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};
export const updateAdmin = async (params) => {
  try {
    const res = await instance().put("auth/update-admin", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};
export const adminChangePassword = async (params) => {
  try {
    const res = await instance().put("auth/admin-change-password", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

//DASHBOARD
export const getDashboardCount = async (params) => {
  try {
    const res = await instance().get("dashboard-count", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};
export const getMonthlyAppliedJobCounts = async (params) => {
  try {
    const res = await instance().get("monthly-applied-count", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

export const getCompanyCountByIndustry = async (params) => {
  try {
    const res = await instance().get("company-by-industry-count", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//INDUSTRIES
export const getIndustries = async (params) => {
  try {
    const res = await instance().get("industries?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};
export const deleteIndustry = async (params) => {
  try {
    const res = await instance().delete(`delete-industries/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};
export const createIndustry = async (params) => {
  try {
    const res = await instance().post("add-industry", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};
export const updateIndustry = async (params) => {
  try {
    const res = await instance().put(
      `update-industry/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

//JOB TYPES
export const getJobType = async (params) => {
  try {
    const res = await instance().get("job-type?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};
export const deleteJobType = async (params) => {
  try {
    const res = await instance().delete(`delete-job-type/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};
export const createJobType = async (params) => {
  try {
    const res = await instance().post("add-job-type", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};
export const updateJobType = async (params) => {
  try {
    const res = await instance().put(
      `update-job-type/${params?.id}`,
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

//USER PROFILE

//BANNERS
export const getBanners = async (params) => {
  try {
    const res = await instance().get("banners", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

export const updateBannerSequence = async (params) => {
  try {
    const res = await instance().post("update-banners-sequence", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const createBanners = async (params) => {
  try {
    const res = await instance().post("create-banners", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    errorHandling(error);

    return;
  }
};

export const deleteBanner = async (params) => {
  try {
    const res = await instance().delete(`delete-banners/${params?.id}`);

    return res?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

export const getProfile = async (params) => {
  try {
    const res = await instance().get(`user/user-profile/${params?.id}`, params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//JOBS
export const getAllJobs = async (params) => {
  try {
    const res = await instance().get("job/get-all-job?", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//EMPLOYER

export const updateCompanyProfile = async (params) => {
  try {
    const res = await instance().put(
      `company/update-company-profile/${params?.id}`,
      JSON.stringify(params.params)
    );

    if (checkVersionUpdate(res?.data)) {
      updateVersion();
      return;
    } else {
      if (res?.data) {
        return res?.data;
      } else if (res?.data?.error) {
        showToast(res?.data?.error?.message);
        return;
      }
    }
  } catch (error) {
    if (error?.response?.status === 400) {
    } else {
      errorHandling(error);
    }
    return;
  }
};

//CONTACTS
export const getAllContacts = async (params) => {
  try {
    const res = await instance().get("company/get-all-contacts", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

export const updateContact = async (params) => {
  try {
    const res = await instance().put(
      `company/update-contact/${params?.id}`,
      JSON.stringify(params.params)
    );

    if (checkVersionUpdate(res?.data)) {
      updateVersion();
      return;
    } else {
      if (res?.data) {
        return res?.data;
      } else if (res?.data?.error) {
        showToast(res?.data?.error?.message);
        return;
      }
    }
  } catch (error) {
    if (error?.response?.status === 400) {
    } else {
      errorHandling(error);
    }
    return;
  }
};

//COMPANY

export const getAllCompanyList = async (params) => {
  try {
    const res = await instance().get("company/get-all-company-list", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

export const getCities = async (params) => {
  try {
    const res = await instance().get("cities", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//APPLICANTS
export const getAllApplicants = async (params) => {
  try {
    const res = await instance().get("job/get-all-applicants", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

//USERS
export const getAllUsers = async (params) => {
  try {
    const res = await instance().get("user/get-all-users", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return error;
  }
};

export const updateUserProfile = async (params) => {
  try {
    const res = await instance().put(`user/update-user-profile`, JSON.stringify(params.params));

    if (checkVersionUpdate(res?.data)) {
      updateVersion();
      return;
    } else {
      if (res?.data) {
        return res?.data;
      } else if (res?.data?.error) {
        showToast(res?.data?.error?.message);
        return;
      }
    }
  } catch (error) {
    if (error?.response?.status === 400) {
    } else {
      errorHandling(error);
    }
    return;
  }
};

//PRE_SIGNED
export const getPresignedUrl = async (params) => {
  try {
    const res = await instance().get("presignedUrl", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//SPONSORS
export const getSponsors = async (params) => {
  try {
    const res = await instance().get("sponsors", params);

    return res?.data?.data;
  } catch (error) {
    errorHandling(error);
    return;
  }
};

//DELETE ACCOUNT
export const deleteAccount = async (params) => {
  try {
    const res = await instance().post("auth/delete-account", JSON.stringify(params.params));

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};

export const verifyDeleteAccount = async (params) => {
  try {
    const res = await instance().post(
      "auth/verify-delete-account-otp",
      JSON.stringify(params.params)
    );

    return res?.data;
  } catch (error) {
    if (error?.response?.status === 400) {
      showToast("Invalid credentials");
    } else {
      errorHandling(error);
    }
    return;
  }
};
